import { useMemo } from 'react';
import { Button } from '@mui/material';
import { CSVLink } from 'react-csv';
import moment from 'moment-timezone';
import { AdvertiserActivityRow } from '../../types/AdvertiserActivity';

const csvHeaders = [
    { label: 'Agency', key: 'agency' },
    { label: 'Advertiser', key: 'advertiser' },
    { label: 'Media Studio', key: 'mediaStudio' },
    { label: 'Ad Tag Status', key: 'hasRecentAdTag' },
];

function getCsvFilename(): string {
    return `Cognition Advertiser Activity Report_${moment().format('YYYYMMDD')}.csv`;
}

function getCsvRow(row: AdvertiserActivityRow): string[] {
    return csvHeaders.map((header) => {
        const value = row[header.key as keyof AdvertiserActivityRow];
        if (typeof value === 'boolean') {
            return value ? 'Yes' : 'No';
        }
        return String(value ?? '');
    });
}

interface AdvertiserActivityExportCsvButtonProps {
    rows: AdvertiserActivityRow[];
}

const AdvertiserActivityExportCsvButton = ({ rows }: AdvertiserActivityExportCsvButtonProps) => {
    const csvData = useMemo(() => rows.map(getCsvRow), [rows]);

    return (
        <CSVLink
            headers={csvHeaders.map((h) => h.label)}
            data={csvData}
            filename={getCsvFilename()}
            style={{ textDecoration: 'none' }}
        >
            <Button variant="outlined" size="medium">
                Export CSV
            </Button>
        </CSVLink>
    );
};

export default AdvertiserActivityExportCsvButton;
